import React from "react";
import './Footer.css'
import {ArrowCircleUp} from "@mui/icons-material";

const currentYear = new Date().getFullYear()

function Footer() {
    return (
        <div className='footer-container'>
            <div className='footer-content'>
                <p>Copyright © {currentYear}. All Rights Reserved.</p>
                <p>Powered by Jogasoft</p>
            </div>

            <ArrowCircleUp onClick={scrollToTop} sx={{fontSize: 30}}/>
        </div>
    )
}

function  scrollToTop() {
    return (window.scrollTo({top: 0, behavior: 'smooth'}))
}

export default Footer;
